import { useCallback, useEffect, useRef, useState } from "react";

import { CatalogPage, ResourceName } from "./CatalogAdmin.types.tsx";
import { PAGE_SIZE, SEARCH_DELAY_MS } from "./resources.tsx";

import { listRecords } from "../../services/catalog.services.tsx";

export const useCatalogList = (resource: ResourceName, version: number) => {
  const [search, setSearch] = useState("");
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(1);
  const [data, setData] = useState<CatalogPage | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<unknown>(null);
  const latest = useRef(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      setQuery(search);
      setPage(1);
    }, SEARCH_DELAY_MS);

    return () => clearTimeout(timer);
  }, [search]);

  const reload = useCallback(async () => {
    const ticket = ++latest.current;
    setLoading(true);

    try {
      const result = await listRecords(resource, query, page, PAGE_SIZE);

      if (ticket === latest.current) {
        setData(result);
        setError(null);
      }
    } catch (caught) {
      if (ticket === latest.current) {
        setError(caught);
      }
    } finally {
      if (ticket === latest.current) {
        setLoading(false);
      }
    }
  }, [resource, query, page]);

  useEffect(() => {
    reload();
  }, [reload, version]);

  const pages = Math.max(1, Math.ceil((data?.total ?? 0) / PAGE_SIZE));

  useEffect(() => {
    if (data && data.items.length === 0 && page > pages) {
      setPage(pages);
    }
  }, [data, page, pages]);

  return { search, setSearch, page, setPage, pages, data, loading, error, reload };
};
